import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api_Url =
  process.env.NEXT_PUBLIC_API_URL || "https://api.itsonlyonestop.com";

import eventTracker from "../../../utils/analytics";
import EVENT_NAMES from "../../../utils/eventNames";

export const addItemToCartThunk = createAsyncThunk(
  "add-item-to-cart",
  async ({ data, token }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const response = await axios.post(
        `${api_Url}/api/add-item-to-cart`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Track Item Added to Cart Event
      eventTracker.track(EVENT_NAMES.ADD_ITEM_TO_CART, {
        userId: state?.auth?.user?.user?.id,
        email: state?.auth?.user?.user?.email,
        data,
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
      return rejectWithValue(error?.response?.data || "Unknown error");
    }
  }
);

export const updateItemToCartThunk = createAsyncThunk(
  "update-item-to-cart",
  async ({ data, token }) => {
    try {
      const response = await axios.post(`${api_Url}/api/update-cart`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getCartListThunk = createAsyncThunk(
  "get-cart-list",
  async ({ token }) => {
    try {
      const response = await axios.get(`${api_Url}/api/cart-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getCartDetailsThunk = createAsyncThunk(
  "get-cart-details",
  async ({ token, data }) => {
    try {
      const response = await axios.get(`${api_Url}/api/cart-details`, {
        params: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getCartPriceDetailsThunk = createAsyncThunk(
  "get-cart-price-details",
  async ({ token, data }) => {
    try {
      const response = await axios.get(`${api_Url}/api/cart-price-details`, {
        params: data,
        headers: {
          Authorization: `Bearer ${token} `,
        },
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const updateDeliveryMethodThunk = createAsyncThunk(
  "update-delivery-method",
  async ({ data, token }) => {
    try {
      const response = await axios.post(
        `${api_Url}/api/cart/update-delivery-method`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getFinalPriceDetailsThunk = createAsyncThunk(
  "cart-final-price-details",
  async ({ token, cart_id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${api_Url}/api/cart-final-price-details`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log("error:", error);
      return rejectWithValue(error?.response?.data || "Unknown error");
    }
  }
);

export const removeCartThunk = createAsyncThunk(
  "remove-cart",
  async ({ data, token }, { getState }) => {
    try {
      const state = getState();

      const response = await axios.post(`${api_Url}/api/remove-cart`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Track Item Added to Cart Event
      eventTracker.track(EVENT_NAMES.REMOVED_CART, {
        userId: state?.auth?.user?.user?.id,
        email: state?.auth?.user?.user?.email,
        data,
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const clearCartThunk = createAsyncThunk(
  "clear-cart",
  async ({ token }, { getState }) => {
    try {
      const state = getState();
      const response = await axios.post(`${api_Url}/api/clear-cart`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      eventTracker.track(EVENT_NAMES.CART_CLEARED, {
        userId: state?.auth?.user?.user?.id,
        email: state?.auth?.user?.user?.email,
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const createOrderThunk = createAsyncThunk(
  "create-order",
  async ({ token }, { getState }) => {
    try {
      const state = getState();
      const response = await axios.post(`${api_Url}/api/create-order`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const orderData = response?.data?.data;
      // Track Order Placed Event
      eventTracker.track(EVENT_NAMES.ORDER_PLACED, {
        userId: state?.auth?.user?.user?.id,
        email: state?.auth?.user?.user?.email,
        orderData,
      });

      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getOrderListThunk = createAsyncThunk(
  "get-order-list",
  async ({ token }) => {
    try {
      const response = await axios.get(`${api_Url}/api/order-list`, {
        params: { role: "user" },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getOrderDetailsThunk = createAsyncThunk(
  "get-order-details",
  async ({ token, orderId }) => {
    try {
      const response = await axios.get(
        `${api_Url}/api/order-details/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getOrderTransationListThunk = createAsyncThunk(
  "get-order-transaction-list",
  async ({ token }) => {
    try {
      const response = await axios.get(
        `${api_Url}/api/order-transaction-list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getOrderTransationDetailsThunk = createAsyncThunk(
  "get-order-transaction-details",
  async ({ token, transaction_id }) => {
    try {
      const response = await axios.get(
        `${api_Url}/api/order-transaction-details`,
        {
          params: { transaction_id },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getFilteredOrderListThunk = createAsyncThunk(
  "get-order-list",
  async ({ token, params }) => {
    try {
      const response = await axios.get(`${api_Url}/api/order-list-filter`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const cancelOrderThunk = createAsyncThunk(
  "cancel-order-and-refund-payment",
  async ({ token, data }) => {
    try {
      const response = await axios.post(
        `${api_Url}/api/cancel-order-and-refund-payment`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

export const getCartInfoThunk = createAsyncThunk(
  "get-cart-information",
  async ({ token, data }) => {
    try {
      const response = await axios.get(`${api_Url}/api/vendor/cart-info`, {
        params: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);
